




















































import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import Kpi from "@/components/dashboard/kpi.vue";
import PresentUsers from "@/components/dashboard/present-users.vue";
import KpiTable from "@/components/dashboard/kpi-table.vue";
import { dashboardService, Stats } from "@/services/dash";
import { Watch } from "vue-property-decorator";
import KpiCards from "@/components/dashboard/kpi-cards.vue";

@Component({
    name: "dashboard",
    components: { KpiCards, KpiTable, PresentUsers, Kpi, Page },
})
export default class Dashboard extends Vue {
    stats: Stats = null;

    @Watch("$context.customer", {
        immediate: true,
    })
    async onCustomerChange(customer) {
        if (!customer) return;
        this.stats = await dashboardService.find({
            params: {
                customer: customer.id,
            },
        });
    }
}
